<template>
    <div>
        <irsh-card v-for="item in cards" :key="item.path" :card="item" :class="cardClass"
            :header-type="cardHeaderType"/>            
    </div>
</template>

<script>
    import card from './Card'

    export default {
        components: {
            'irsh-card': card
        },
        props: {
            cards: {
                type: Array,
                default: []
            },
            cardClass: {
                type: String
            },
            cardHeaderType: {
                type: String
            }
        }
    }
</script>